// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3JSJb","title":"Header_title__2eSgS","side":"Header_side__3NCSR"};